// Component: HTML5Video
// Author: Jay
import * as React from 'react';
import VideoComp from '@component/HTML5Video';
import { Text } from '@sitecore-jss/sitecore-jss-react';

export default function HTML5Video(props) {
  return (
    <>
      <VideoComp
        url={props.fields?.Url?.value}
        poster={props.fields?.PosterUrl?.value}
        filename={props.fields?.FileName?.value}
        addCheckbox={props.fields?.AddContainer?.value}
        caption={props.fields?.Caption?.value}
        removeMargin={props.fields?.RemoveMargin?.value}
      />
    </>
  );
}
